<app-title-header *ngIf="_usuario.typ_id == 1"
  [title]= '_title'
  [subtitle]='_subtitle'>
</app-title-header>

<div class="configurar-agenda">

  <h3>Selecciona un día para configurar tu agenda</h3>
  
  <div class="div-calendar">
    <app-calendar-month
      (messageEvent)='clickDayCalendar($event)'>
    </app-calendar-month>
  </div>
  

  <div class="div-selected-day" *ngIf="selected_day.day">

    <div class="not-hours" *ngIf="(dia_editable == false)" style="margin-top: 60px;">
      <div style="display: flex; color: #0e0087;">
        <mat-icon>info</mat-icon>
        <span>No puedes  bloquear / habilitar horas para este día.</span>
      </div>
    </div>
    
    <div class="bloquear-horas" *ngIf="(dia_editable == true)">
      <h3 style="margin-bottom: 20px;">Horas disponibles para bloquear al {{selected_day.weekday}} {{selected_day.day}} de {{selected_day.month}} {{selected_day.year}}</h3>
      <div class="not-hours" *ngIf="(num_hours_bloqueables == 0)">
        <div style="display: flex; color: #0e0087;">
          <mat-icon>info</mat-icon>
          <span>No tiene horas disponibles para bloquear</span>
        </div>
      </div>

      <div class="box-container">

        <div class="blocks-hour">
          <div class="" *ngFor="let itemHour of hours_selected_day">
            <button *ngIf="(tipoAgenda === 'reserva') && (_usuario.typ_id == 8)"
              [ngClass]="{
                'btn hour-btn-habilitada': itemHour.bloqueable && !itemHour.is_ondemand,
                'btn hour-btn-seleccionada': itemHour.bloqueable && itemHour.selected_bloq,
                'btn hour-btn-bloqueada': !itemHour.bloqueable,
                'btn hour-btn-bloqueada-od': itemHour.bloqueable && itemHour.is_ondemand
              }"
              [disabled]="!itemHour.sta_id || itemHour.is_ondemand"
              (click)="clickHourBloquear(itemHour)">
              {{ itemHour.from }}
            </button>

            <button *ngIf="(tipoAgenda === 'ondemand') && (_usuario.typ_id == 8)"
            [ngClass]="{
              'btn hour-btn-habilitada-od': !itemHour.habilitable && itemHour.is_ondemand,
              'btn hour-btn-seleccionada-od': itemHour.bloqueable && itemHour.selected_bloq,
              'btn hour-btn-bloqueada': itemHour.bloqueable && !itemHour.is_ondemand,
              'btn hour-btn-bloqueada-od':!itemHour.bloqueable
            }"
            [disabled]="!itemHour.sta_id || !itemHour.is_ondemand"
            (click)="clickHourBloquear(itemHour)">
            {{ itemHour.from }}
          </button>
          <button 
          *ngIf=" (_usuario.typ_id == 1 || _usuario.typ_id == 7)"
            [ngClass]="{
              'btn hour-btn-habilitada': itemHour.bloqueable && !itemHour.is_ondemand,
                'btn hour-btn-seleccionada': itemHour.bloqueable && itemHour.selected_bloq,
                'btn hour-btn-bloqueada': !itemHour.bloqueable,
                'btn hour-btn-bloqueada-od': itemHour.is_ondemand
            }"
            [disabled]="!itemHour.sta_id || itemHour.is_ondemand"
            (click)="clickHourBloquear(itemHour)"> 
            {{ itemHour.from }}
          </button>

          </div>
        </div>
        

        <hr style="border: 1px solid #B8B8B8; margin: 30px 0;">

        <div class="confirm-hour">
          <div class="row">
            <div class="col-8" style="padding: 12px;">
              <input id="check-selected-hour-bloq" type="checkbox" 
                [(ngModel)]="checkBloquear"
                class="chk-col-light-blue"
                (change)="checkHourBloq()"
                [disabled]="(num_hours_bloqueables == 0)">
              <label for="check-selected-hour-bloq">Seleccionar todas las horas disponibles</label>
            </div>
            <div class="col-sm-12 col-md-4 btn-habilitar" style="text-align: right;">
              <button class="btn btn-primary" [disabled]="!btnBloquear" data-toggle="modal" data-target="#bloquearHorasModal" (click)="bloquearHoras()">Bloquear horas</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="habilitar-horas" *ngIf="(dia_editable == true) || _usuario.typ_id == 8">
      <h3 style="margin-bottom: 20px;">Horas disponibles para habilitar al {{selected_day.weekday}} {{selected_day.day}} de {{selected_day.month}} {{selected_day.year}}</h3>
      <!-- <div class="not-hours" *ngIf="(num_hours_habilitables == 0)">
        <div style="display: flex; color: #0e0087;">
          <mat-icon>info</mat-icon>
          <span>No tiene horas disponibles para habilitar</span>
        </div>
      </div> -->

      <div class="box-container" *ngIf="(num_hours_habilitables != 0) || _usuario.typ_id == 8">

        <div class="blocks-hour">
          <div class="" *ngFor="let itemHour of hours_selected_day">
        
            <!-- CC o CM (tipos 1 y 7) -->
            <button *ngIf="_usuario.typ_id == 1 || _usuario.typ_id == 7"
              [ngClass]="{
                'btn hour-btn-habilitada': itemHour.habilitable && !itemHour.is_ondemand,
                'btn hour-btn-seleccionada': itemHour.habilitable && itemHour.selected_hab,
                'btn hour-btn-bloqueada': !itemHour.habilitable,
                'btn hour-btn-bloqueada-od': itemHour.is_ondemand
              }"
              [disabled]="!itemHour.sta_id || itemHour.is_ondemand"
              (click)="clickHourHabilitar(itemHour)">
              {{ itemHour.from }}
            </button>
        
            <!-- Admin (typ_id 8) -->
            <button *ngIf="_usuario.typ_id == 8 && tipoAgenda === 'reserva'"
              [ngClass]="{
                'btn hour-btn-habilitada': (itemHour.habilitable || itemHour.spe_id == -1),
                'btn hour-btn-seleccionada': (itemHour.habilitable || itemHour.spe_id == -1) && itemHour.selected_hab,
                'btn hour-btn-bloqueada-od': itemHour.bloqueable && itemHour.is_ondemand === true,
                'btn hour-btn-bloqueada': !itemHour.habilitable && !itemHour.spe_id
              }"
              [disabled]="itemHour.sta_id == 21 || (itemHour.is_ondemand && itemHour.sta_id == 21) || itemHour.sta_id == 24"
              (click)="clickHourHabilitar(itemHour)">
              {{ itemHour.from }}
            </button>
        
            <button *ngIf="_usuario.typ_id == 8 && tipoAgenda === 'ondemand'"
              [ngClass]="{
                'btn hour-btn-habilitada-od': (itemHour.habilitable || itemHour.spe_id == -1), 
                'btn hour-btn-seleccionada-od': itemHour.selected_hab,
                'btn hour-btn-bloqueada': (itemHour.bloqueable && itemHour.is_ondemand === false) || itemHour.sta_id== 24,
                'btn hour-btn-bloqueada-od': !itemHour.habilitable && itemHour.is_ondemand === true
              }"
              [disabled]="itemHour.sta_id == 21 || itemHour.sta_id == 24"
              (click)="clickHourHabilitar(itemHour)">
              {{ itemHour.from }}
            </button>
        
          </div>
        </div>
        

        <hr style="border: 1px solid #B8B8B8; margin: 30px 0;">

        <div class="confirm-hour">
          <div class="row">
            <div class="col-8" style="padding: 12px;">
              <input id="check-selected-hour" type="checkbox" 
                [(ngModel)]="checkHabilitar"
                class="chk-col-light-blue"
                (change)="checkHourHab()"
                [disabled]="(num_hours_habilitables == 0)">
              <label for="check-selected-hour">Seleccionar todas las horas bloqueadas</label>

              <input id="check-selected-all-hours" type="checkbox" 
                *ngIf="_usuario.typ_id == 8"
                [(ngModel)]="checkHabilitarNoBloqueadas"
                class="chk-col-light-blue"
                (change)="checkHourHabNoBloq()"
                [disabled]="!boolCheckHourHabNoBloq()">
              <label  *ngIf="_usuario.typ_id == 8" for="check-selected-all-hours">Seleccionar todas las horas no bloqueadas</label>





            </div>
            <div class="col-sm-12 col-md-4 btn-habilitar" style="text-align: right;">
              <button class="btn btn-primary" [disabled]="!btnHabilitar" data-toggle="modal" data-target="#habilitarHorasModal" (click)="habilitarHoras()">Habilitar horas</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>




<!-- Modales --> 
<!-- Confirmar bloqueo -->
<div class="modal fade" id="bloquearHorasModal" tabindex="-1" role="dialog" aria-hidden="true" >
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header mx-auto" style="border: none;">
        <h2 *ngIf="tipoAgenda === 'ondemand'" class="modal-title" style="text-align: center; color: #2F7586;">¿Está seguro que desea bloquear las siguientes horas?</h2>
        <h2 *ngIf="tipoAgenda === 'reserva'" class="modal-title" style="text-align: center; color: #0e0087;">¿Está seguro que desea bloquear las siguientes horas?</h2>
        <h2 *ngIf="!tipoAgenda" class="modal-title" style="text-align: center; color: #0e0087;">¿Está seguro que desea bloquear las siguientes horas?</h2>
      </div>
      <div class="modal-body" style="border: none;">
        <h3 *ngIf="tipoAgenda === 'ondemand'" class="modal-title" style="margin: 20px 0; color: #2F7586;" >Resumen de horas por bloquear</h3>
        <h3 *ngIf="tipoAgenda === 'reserva'" class="modal-title" style="margin: 20px 0; color: #0e0087;" >Resumen de horas por bloquear</h3>
        <h3 *ngIf="!tipoAgenda" class="modal-title" style="margin: 20px 0; color: #0e0087;" >Resumen de horas por bloquear</h3>
        <div class="card" [ngStyle]="{'border-bottom': (tipoAgenda === 'ondemand') ? '10px solid #2F7586' : '10px solid #316AD8;'}">
          <h4 *ngIf="tipoAgenda === 'ondemand'" style="color: #2F7586;">Doctor o profesional: {{nombre_medico}}</h4>
             <h4 *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" style="color: #0e0087;">Doctor o profesional: {{nombre_medico}}</h4>          <p style="font-size: 18px;"><strong>Fecha de bloqueos:</strong> {{selected_day.weekday}} {{selected_day.day}} de {{selected_day.month}} {{selected_day.year}}</p>
          <div class="blocks-hour">
            <div class="" *ngFor="let itemHour of hours_selected_bloquear">
              <button *ngIf="tipoAgenda === 'ondemand'" style="cursor: default;" class="btn hour-btn-seleccionada_od">{{ itemHour.from }}</button>
              <button *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" style="cursor: default;" class="btn hour-btn-seleccionada">{{ itemHour.from }}</button>

            </div>
          </div>
        </div>
        <label  *ngIf="tipoAgenda === 'ondemand'" style="color: #2F7586;">Recuerda que puedes habilitar las horas que estás bloqueando.</label>
        <label  *ngIf="tipoAgenda === 'reserva'" style="color: #0e0087;">Recuerda que puedes habilitar las horas que estás bloqueando.</label>
        <label  *ngIf="!tipoAgenda" style="color: #0e0087;">Recuerda que puedes habilitar las horas que estás bloqueando.</label>

        <textarea class="form-control" rows="4" style="padding-top: 10px;" name="edit_reason" [(ngModel)]="edit_reason" id="edit_reason" placeholder="Motivo de bloqueo"></textarea>
        <div class="text-danger" *ngIf="(edit_reason.length < 4)">
          <p class="d-flex"><mat-icon>highlight_off</mat-icon> Debes ingresar un motivo de bloqueo</p>
        </div>

      </div>
      <div class="modal-footer" style="border: none; padding-left: 30px;">
        <div style="width: 50%;">
          <button type="button" class="btn" [ngClass]="(tipoAgenda === 'ondemand') ? 'btn-volver-od' : 'btn-volver'" data-dismiss="modal" style="float: left;">Cerrar</button>
        </div>
        <div style="width: 50%;">
          <button *ngIf="tipoAgenda === 'ondemand'" class="btn btn-confirmar" data-dismiss="modal" (click)="confirmarBloquearHoras()" style="float: right; background-color: #2F7586; border: 2px solid #2F7586;" [disabled]="(edit_reason.length < 4)">Confirmar bloqueo</button>
          <button *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" class="btn btn-confirmar" data-dismiss="modal" (click)="confirmarBloquearHoras()" style="float: right; background-color: #0e0087; border: 2px solid #171994;" [disabled]="(edit_reason.length < 4)">Confirmar bloqueo</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Confirmar Habilitar-->
<div class="modal fade" id="habilitarHorasModal" tabindex="-1" role="dialog" aria-hidden="true" >
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header mx-auto" style="border: none;">
        <h2 *ngIf="tipoAgenda === 'ondemand'" class="modal-title" style="text-align: center; color: #2F7586;">
          ¿Está seguro que desea habilitar las siguientes horas para atención inmediata?
        </h2>
        <h2 *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" class="modal-title" style="text-align: center; color: #0e0087;">
          ¿Está seguro que desea habilitar las siguientes horas?
        </h2>
        <h2 *ngIf="!tipoAgenda" class="modal-title" style="text-align: center; color: #0e0087;">
          ¿Está seguro que desea habilitar las siguientes horas?
        </h2>
              </div>
      <div class="modal-body" style="border: none;">
        <h3 *ngIf="hours_selected_habilitar.length >0 && tipoAgenda === 'ondemand'" class="modal-title" style="margin: 20px 0; color: #2F7586;" >Resumen de horas por desbloquear</h3>
        <h3 *ngIf="hours_selected_habilitar.length >0 && tipoAgenda === 'reserva' || !tipoAgenda" class="modal-title" style="margin: 20px 0; color: #0e0087;" >Resumen de horas por desbloquear</h3>
        <div *ngIf="hours_selected_habilitar.length >0" [ngStyle]="{'border-bottom': (tipoAgenda === 'ondemand') ? '10px solid #2F7586' : '10px solid #316AD8;'}" class="card">
          <h4 *ngIf="tipoAgenda === 'ondemand'" style="color: #2F7586;">Doctor o profesional: {{nombre_medico}}</h4>
          <h4 *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" style="color: #0e0087;">Doctor o profesional: {{nombre_medico}}</h4>
          <p style="font-size: 18px;"><strong>Fecha de habilitación:</strong> {{selected_day.weekday}} {{selected_day.day}} de {{selected_day.month}} {{selected_day.year}}</p>
          <div class="blocks-hour">
            <div class="" *ngFor="let itemHour of hours_selected_habilitar">
              <button *ngIf="tipoAgenda === 'ondemand'" style="cursor: default;" class="btn hour-btn-seleccionada-od">{{ itemHour.from }}</button>
              <button *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" style="cursor: default;" class="btn hour-btn-seleccionada">{{ itemHour.from }}</button>
            </div>
          </div>
        </div>
        <h3 *ngIf="hours_selected_habilitar_no_bloq.length >0 && tipoAgenda === 'ondemand'" class="modal-title" style="margin: 20px 0; color: #2F7586;" >Resumen de horas por habilitar</h3>
        <h3 *ngIf="hours_selected_habilitar_no_bloq.length >0 && tipoAgenda === 'reserva'" class="modal-title" style="margin: 20px 0; color: #0e0087;" >Resumen de horas por habilitar</h3>
        <div *ngIf="hours_selected_habilitar_no_bloq.length >0" [ngStyle]="{'border-bottom': (tipoAgenda === 'ondemand') ? '10px solid #2F7586' : '10px solid #316AD8;'}" class="card">
          <h4 *ngIf="tipoAgenda === 'ondemand'" style="color: #2F7586;">Doctor o profesional: {{nombre_medico}}</h4>
          <h4 *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" style="color: #0e0087;">Doctor o profesional: {{nombre_medico}}</h4>          <p style="font-size: 18px;"><strong>Fecha de habilitación:</strong> {{selected_day.weekday}} {{selected_day.day}} de {{selected_day.month}} {{selected_day.year}}</p>
          <div class="blocks-hour">
            <div class="" *ngFor="let itemHour of hours_selected_habilitar_no_bloq">
              <button *ngIf="tipoAgenda === 'ondemand'" style="cursor: default;" class="btn hour-btn-seleccionada-od">{{ itemHour.from }}</button>
              <button *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" style="cursor: default;" class="btn hour-btn-seleccionada">{{ itemHour.from }}</button>
            </div>
          </div>
        </div>
        <label *ngIf="tipoAgenda === 'ondemand'" style="color: #2F7586;">Recuerda que puedes bloquear las horas que estás habilitando.</label>
        <label *ngIf="tipoAgenda === 'reserva' || !tipoAgenda" style="color: #0e0087;">Recuerda que puedes bloquear las horas que estás habilitando.</label>
        <div *ngIf="(hours_selected_habilitar.length > 0)" >
          <textarea class="form-control" rows="4" style="padding-top: 10px;" name="edit_reason" [(ngModel)]="edit_reason" id="edit_reason" placeholder="Motivo de desbloqueo"></textarea>
          <div class="text-danger" *ngIf="(edit_reason.length < 4)">
            <p class="d-flex"><mat-icon>highlight_off</mat-icon> Debes ingresar un motivo de desbloqueo</p>
          </div>
        </div>

      </div>
      <div class="modal-footer" style="border: none; padding-left: 30px;">
        <div style="width: 50%;">
          <button type="button" class="btn" [ngClass]="(tipoAgenda === 'ondemand') ? 'btn-volver-od' : 'btn-volver'" data-dismiss="modal" style="float: left;">Cerrar</button>
        </div>
        <div style="width: 50%;">
          <button class="btn btn-confirmar" data-dismiss="modal" (click)="confirmarHabilitarHoras()" style="float: right; background-color: #2F7586; border: 2px solid #2F7586;" *ngIf="(hours_selected_habilitar.length == 0 && tipoAgenda === 'ondemand')">Confirmar habilitación</button>
          <button class="btn btn-confirmar" data-dismiss="modal" (click)="confirmarHabilitarHoras()" style="float: right; background-color: #0e0087; border: 2px solid #171994;" *ngIf="(hours_selected_habilitar.length == 0 && tipoAgenda === 'reserva')">Confirmar habilitación</button>
          <button class="btn btn-confirmar" data-dismiss="modal" (click)="confirmarHabilitarHoras()" 
            style="float: right; background-color: #2F7586; border: 2px solid #2F7586;" *ngIf="(hours_selected_habilitar.length > 0 && tipoAgenda === 'ondemand')" [disabled]="(edit_reason.length < 4)">Confirmar desbloqueo</button>
          <button class="btn btn-confirmar" data-dismiss="modal" (click)="confirmarHabilitarHoras()" 
            style="float: right; background-color: #0e0087; border: 2px solid #171994;" *ngIf="(hours_selected_habilitar.length > 0 && (tipoAgenda === 'reserva' || !tipoAgenda))" [disabled]="(edit_reason.length < 4)">Confirmar desbloqueo</button>
        </div>
      </div>
    </div>
  </div>
</div>
